export default function formatDateLabel(currentPeriod: string, date: Date) {
	if (
		currentPeriod === 'hour' ||
		currentPeriod === 'day' ||
		currentPeriod === '1d' ||
		currentPeriod === '1h'
	) {
		return date.toLocaleTimeString('en-US', {
			hour12: false,
			hour: '2-digit',
			minute: '2-digit',
		});
	}
	if (
		currentPeriod === 'week' ||
		currentPeriod === 'month' ||
		currentPeriod === '7d' ||
		currentPeriod === '30d'
	) {
		return date.toLocaleString('en', { day: 'numeric', month: 'short' }).toUpperCase();
	}
	if (currentPeriod === 'year' || currentPeriod === '365d') {
		return date.toLocaleString('en', { month: 'short', year: '2-digit' }).toUpperCase();
	}
}
